// src/data/seo-config.js
// One entry per route. Used by <SEO /> (see src/components/SEO.js) to
// auto-inject <title>, meta description, canonical URL, and JSON-LD schema
// for whichever page is currently rendered — no need to touch each page file.

export const SITE_URL = "https://www.prhospitaldesigners.com";
export const SITE_NAME = "PR Hospital Designers";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`; // add a 1200x630 image at public/og-image.jpg

// Cities you serve — used to build the "areaServed" list on service pages
// and the LocalBusiness schema on city landing pages.
const CITIES = [
  "Hyderabad", "Narsapur", "Sangareddy", "Jangaon", "Mahabubnagar",
  "Indresham", "Bhuvanagiri", "Khammam", "Rajahmundry", "Vijayawada",
];

// type: "service" | "city" | "article" | "page"
const seoConfig = {
  "/": {
  type: "page",
  title: "PR Hospital Designers | Hospital Design & Infrastructure",
  description:
    "PR Hospital Designers provides NABH-compliant hospital design, construction, OT and ICU fit-outs, diagnostic centre design, patient ward planning and complete healthcare infrastructure solutions across India.",
  keywords:
    "hospital designers, hospital design, hospital construction, hospital architects, hospital infrastructure, hospital consultants, hospital interior design, OT design, ICU design, NABH hospital design, diagnostic centre design, patient ward design, healthcare infrastructure",
  priority: 1.0,
},

  "/projects": {
  type: "page",
  title: "Our Projects | Hospital & Interior Design Portfolio | PR Hospital Designers",
  description:
    "Explore completed hospital design-build projects delivered by PR Hospital Designers across Telangana and Andhra Pradesh.",
  keywords:
    "hospital projects, hospital design projects, hospital construction projects, hospital interior design projects, healthcare infrastructure projects, hospital architecture portfolio, hospital designers, hospital interior designers, hospital construction Telangana, hospital construction Andhra Pradesh",
  priority: 0.8,
},

  "/magazine": {
    type: "page",
    title: "Magazine | Design Insights & Ideas | PR Hospital Designers",
    description: "Articles and insights on hospital planning, NABH compliance, and interior design from the PR Hospital Designers team.",
    priority: 0.5,
  },
  "/about": {
  type: "page",
  title: "About PR Hospital Designers | Hospital Design & Construction Experts",
  description:
    "Learn about PR Hospital Designers, specialists in hospital architecture, planning, construction, interior design and complete healthcare infrastructure solutions.",
  keywords:
    "about PR Hospital Designers, hospital designers, hospital design company, hospital architects, hospital construction company, healthcare infrastructure, hospital consultants, hospital interior designers, hospital planning, NABH hospital design",
  priority: 0.7,
},
  "/consult": {
  type: "page",
  title: "Free Hospital Design Consultation | PR Hospital Designers",
  description:
    "Talk to PR Hospital Designers for expert guidance on hospital architecture, planning, construction, interiors, NABH compliance and healthcare infrastructure.",
  keywords:
    "hospital design consultation, free hospital consultation, hospital design consultant, hospital architecture consultation, hospital planning consultant, hospital construction consultant, hospital interior design consultant, NABH consultant, healthcare infrastructure consultant, PR Hospital Designers",
  priority: 0.6,
},
  "/cost-calculator": {
  type: "page",
  title: "Hospital Interior Cost Calculator | PR Hospital Designers",
  description:
    "Estimate the cost of your hospital design, construction and interior project with the PR Hospital Designers cost calculator.",
  keywords:
    "hospital cost calculator, hospital construction cost calculator, hospital interior cost calculator, hospital design cost, hospital construction cost, hospital interior cost, healthcare facility cost, hospital project cost estimation, hospital planning cost, PR Hospital Designers",
  priority: 0.6,
},
  "/architects-construction": {
  type: "service",
  title: "Hospital Architecture & Construction | PR Hospital Designers",
  description:
    "PR Hospital Designers provides complete hospital architecture, planning, construction and healthcare infrastructure solutions for modern hospitals.",
  keywords:
    "hospital architecture, hospital construction, hospital architects, hospital design, healthcare architecture, healthcare construction, hospital planning, hospital infrastructure, hospital architects Telangana, hospital construction Andhra Pradesh",
  priority: 0.7,
},
"/3d-designs": {
  type: "service",
  title: "3D Hospital & Interior Designs | PR Hospital Designers",
  description:
    "Explore realistic 3D hospital and interior design visualizations by PR Hospital Designers, helping clients visualize layouts, spaces, finishes and healthcare environments before construction.",
  keywords:
    "3D hospital design, 3D hospital visualization, hospital 3D design, 3D interior design, hospital interior design, healthcare interior design, hospital architecture 3D, hospital design visualization, hospital planning, hospital designers",
  priority: 0.6,
},
"/nabh-consultant": {
  type: "service",
  title: "NABH Consultant | NABH Compliance Experts | PR Hospital Designers",
  description:
    "Get expert NABH consultancy and compliance support from PR Hospital Designers to help hospitals prepare for NABH accreditation, improve standards and achieve regulatory compliance.",
  keywords:
    "NABH consultant, NABH consultancy, NABH accreditation consultant, NABH compliance, NABH hospital consultant, hospital NABH accreditation, NABH certification, hospital compliance consultant, NABH standards, NABH preparation",
  priority: 0.7,
},
"/plumbing-electrical": {
  type: "service",
  title: "Hospital Plumbing & Electrical Services | PR Hospital Designers",
  description:
    "PR Hospital Designers provides complete hospital plumbing and electrical infrastructure solutions designed for safe, reliable and efficient healthcare facilities.",
  keywords:
    "hospital plumbing, hospital electrical services, hospital plumbing services, hospital electrical infrastructure, hospital MEP services, healthcare electrical systems, hospital infrastructure, hospital construction, hospital design, hospital facility services",
  priority: 0.6,
},
"/medical-gases": {
  type: "service",
  title: "Medical Gas Pipeline Systems | PR Hospital Designers",
  description:
    "PR Hospital Designers provides medical gas pipeline system design and installation solutions for hospitals, supporting safe, reliable and efficient healthcare infrastructure.",
  keywords:
    "medical gas pipeline systems, hospital medical gases, medical gas installation, medical gas pipeline design, hospital gas pipeline, medical gas system, hospital infrastructure, hospital construction, healthcare infrastructure",
  priority: 0.6,
},
"/ivf": {
  type: "service",
  title: "IVF Centre Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides specialized IVF and fertility centre design and setup solutions focused on functional layouts, clinical workflow, patient comfort and healthcare infrastructure requirements.",
  keywords:
    "IVF centre design, IVF centre setup, fertility centre design, IVF hospital design, fertility clinic design, IVF infrastructure, IVF clinic setup, fertility centre planning, healthcare infrastructure, hospital designers",
  priority: 0.6,
},
"/fire-safety": {
  type: "service",
  title: "Hospital Fire Safety Systems | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital fire safety planning and infrastructure solutions focused on fire prevention, emergency preparedness, compliance and patient safety.",
  keywords:
    "hospital fire safety, hospital fire safety systems, hospital fire protection, hospital fire safety planning, fire safety for hospitals, healthcare fire safety, hospital fire protection systems, hospital infrastructure, hospital compliance, hospital designers",
  priority: 0.6,
},
"/hvac": {
  type: "service",
  title: "Hospital HVAC Systems | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital HVAC design and installation solutions for ventilation, temperature control, air quality and efficient healthcare environments.",
  keywords:
    "hospital HVAC, hospital HVAC systems, hospital HVAC design, hospital HVAC installation, healthcare HVAC, hospital ventilation systems, hospital air conditioning, hospital air quality, HVAC for hospitals, hospital infrastructure",
  priority: 0.6,
},
"/cctv-networking": {
  type: "service",
  title: "Hospital CCTV & Networking Setup | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital-wide CCTV surveillance and IT networking solutions for secure, connected and efficient healthcare facilities.",
  keywords:
    "hospital CCTV, hospital CCTV surveillance, hospital networking, hospital IT networking, CCTV setup for hospitals, hospital security systems, healthcare networking, hospital network infrastructure, hospital surveillance systems, hospital infrastructure",
  priority: 0.5,
},
"/nurse-calling": {
  type: "service",
  title: "Nurse Calling Systems | PR Hospital Designers",
  description:
    "PR Hospital Designers provides reliable nurse calling system solutions for hospital patient wards, ICUs and healthcare facilities, supporting fast communication between patients and medical staff.",
  keywords:
    "nurse calling systems, hospital nurse call system, nurse call systems for hospitals, hospital communication systems, nurse call system for ICU, patient nurse calling system, hospital ward communication, healthcare communication systems, hospital infrastructure",
  priority: 0.5,
},
"/access-control": {
  type: "service",
  title: "Hospital Access Control Systems | PR Hospital Designers",
  description:
    "PR Hospital Designers provides secure access control systems for hospitals, helping manage restricted areas, improve facility security and support safe healthcare environments.",
  keywords:
    "hospital access control, hospital access control systems, healthcare access control, hospital security systems, access control for hospitals, hospital security solutions, restricted access systems, hospital infrastructure, healthcare security",
  priority: 0.5,
},
"/epbax": {
  type: "service",
  title: "EPBAX Communication Systems | PR Hospital Designers",
  description:
    "PR Hospital Designers provides EPBAX telephony and communication system solutions for hospitals, enabling reliable internal communication between departments, staff and healthcare facilities.",
  keywords:
    "EPBAX hospital systems, hospital EPBAX, hospital communication systems, EPBAX telephony, hospital telephone systems, hospital intercom systems, healthcare communication systems, hospital communication infrastructure, hospital networking",
  priority: 0.5,
},
"/interior-services": {
  type: "service",
  title: "Hospital Interior Services | PR Hospital Designers",
  description:
    "PR Hospital Designers provides complete hospital interior design and fit-out services for healthcare facilities, focusing on functional spaces, patient comfort, clinical workflows and efficient hospital environments.",
  keywords:
    "hospital interior services, hospital interior design, hospital interior fit out, healthcare interior design, hospital interiors, hospital fit out services, healthcare facility interiors, hospital interior designers, hospital design, hospital infrastructure",
  priority: 0.6,
},
"/modular-operation-theatres": {
  type: "service",
  title: "Modular Operation Theatres | PR Hospital Designers",
  description:
    "PR Hospital Designers provides turnkey modular operation theatre design and construction solutions, covering planning, installation, clinical workflow and healthcare infrastructure requirements.",
  keywords:
    "modular operation theatre, modular OT, modular operation theatre design, modular OT design, operation theatre construction, OT construction, hospital OT design, operation theatre installation, hospital infrastructure, hospital designers",
  priority: 0.7,
},
"/medical-furniture": {
  type: "service",
  title: "Medical Furniture Supply | PR Hospital Designers",
  description:
    "PR Hospital Designers supplies medical-grade furniture for hospitals, clinics and healthcare facilities, supporting functional, safe and efficient clinical environments.",
  keywords:
    "medical furniture, hospital medical furniture, medical furniture supply, hospital furniture, healthcare furniture, medical furniture supplier, hospital furniture supplier, clinic furniture, hospital infrastructure, healthcare equipment",
  priority: 0.5,
},
"/medical-equipment": {
  type: "service",
  title: "Medical Equipment Supply | PR Hospital Designers",
  description:
    "PR Hospital Designers provides medical equipment sourcing and installation solutions for hospitals and healthcare facilities, supporting efficient and reliable clinical environments.",
  keywords:
    "medical equipment supply, hospital medical equipment, medical equipment supplier, hospital equipment supplier, healthcare equipment, medical equipment installation, hospital equipment, healthcare infrastructure, hospital equipment solutions",
  priority: 0.5,
},
"/dialysis-setup": {
  type: "service",
  title: "Dialysis Centre Setup | PR Hospital Designers",
  description:
    "PR Hospital Designers provides complete dialysis centre design and setup solutions, including space planning, clinical workflow, infrastructure and equipment requirements.",
  keywords:
    "dialysis centre setup, dialysis centre design, dialysis unit design, dialysis centre planning, dialysis equipment setup, hospital dialysis centre, dialysis clinic design, dialysis infrastructure, healthcare infrastructure, hospital designers",
  priority: 0.6,
},
"/icu-setup": {
  type: "service",
  title: "ICU Setup | PR Hospital Designers",
  description:
    "PR Hospital Designers provides turnkey ICU setup solutions including ICU layout planning, medical equipment, clinical infrastructure and essential hospital systems.",
  keywords:
    "ICU setup, ICU design, ICU layout design, ICU hospital setup, intensive care unit setup, ICU equipment, ICU infrastructure, hospital ICU design, critical care unit design, hospital designers",
  priority: 0.6,
},
"/biomedical-service": {
  type: "service",
  title: "Biomedical Equipment Services | PR Hospital Designers",
  description:
    "PR Hospital Designers provides biomedical equipment supply, installation and maintenance services for hospitals and healthcare facilities, supporting reliable and efficient clinical operations.",
  keywords:
    "biomedical equipment services, biomedical equipment supply, biomedical equipment installation, biomedical equipment maintenance, hospital biomedical equipment, medical equipment services, hospital equipment maintenance, healthcare equipment services, biomedical engineering services, hospital infrastructure",
  priority: 0.5,
},
"/hospital-administration": {
  type: "service",
  title: "Hospital Administration Consulting | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital administration and operations consulting solutions to help healthcare facilities establish efficient processes, workflows and management systems.",
  keywords:
    "hospital administration consulting, hospital management consulting, hospital operations consulting, healthcare management consulting, hospital administration services, hospital operations setup, healthcare operations, hospital management, hospital consultants",
  priority: 0.5,
},
"/ot-suite-designs": {
  type: "service",
  title: "Operation Theatre Design | OT Suite Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides specialized operation theatre and OT suite design solutions focused on clinical workflow, infection control, safety, functionality and efficient hospital infrastructure.",
  keywords:
    "operation theatre design, OT suite design, OT design, operation theatre planning, hospital OT design, modular OT design, operation theatre layout, OT infrastructure, hospital operation theatre, hospital designers",
  priority: 0.7,
},
"/icu-layout-designs": {
  type: "service",
  title: "ICU Layout Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides efficient and compliant ICU layout design solutions focused on critical care workflows, patient safety, clinical functionality and effective hospital infrastructure.",
  keywords:
    "ICU layout design, ICU design, intensive care unit design, ICU hospital design, critical care unit design, ICU planning, ICU layout planning, hospital ICU layout, ICU infrastructure, hospital designers",
  priority: 0.7,
},
"/patient-ward-designs": {
  type: "service",
  title: "Patient Ward Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides patient ward planning and design solutions focused on patient comfort, hygiene, efficient clinical workflows and functional hospital environments.",
  keywords:
    "patient ward design, hospital ward design, patient ward planning, hospital patient room design, healthcare ward design, hospital ward layout, patient room planning, hospital interior design, healthcare infrastructure, hospital designers",
  priority: 0.7,
},
"/reception-lobby-designs": {
  type: "service",
  title: "Reception & Lobby Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides welcoming and functional hospital reception and lobby design solutions focused on patient experience, efficient movement, accessibility and professional healthcare environments.",
  keywords:
    "hospital reception design, hospital lobby design, reception area design, healthcare reception design, hospital entrance design, hospital interior design, hospital lobby planning, healthcare interior design, hospital designers",
  priority: 0.6,
},
"/diagnostic-room-designs": {
  type: "service",
  title: "Diagnostic Room Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides purpose-built diagnostic room design solutions for imaging, testing and diagnostic departments, focusing on efficient workflows, functionality and patient safety.",
  keywords:
    "diagnostic room design, diagnostic centre design, hospital diagnostic room design, imaging room design, diagnostic department design, medical imaging centre design, diagnostic facility planning, hospital interior design, healthcare infrastructure, hospital designers",
  priority: 0.6, 
},
"/pharmacy-designs": {
  type: "service",
  title: "Hospital Pharmacy Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides efficient and compliant hospital pharmacy layout and design solutions focused on workflow, storage, safety, accessibility and healthcare facility requirements.",
  keywords:
    "hospital pharmacy design, pharmacy layout design, hospital pharmacy layout, pharmacy planning, healthcare pharmacy design, hospital pharmacy planning, medical pharmacy design, hospital interior design, healthcare infrastructure, hospital designers",
  priority: 0.6,
},
"/nursing-station-designs": {
  type: "service",
  title: "Nursing Station Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides ergonomic nursing station design solutions focused on efficient patient monitoring, staff workflow, accessibility and functional hospital environments.",
  keywords:
    "nursing station design, hospital nursing station design, nursing station layout, hospital ward design, nurse station planning, healthcare interior design, patient monitoring station, hospital workflow design, hospital infrastructure, hospital designers",
  priority: 0.6,
},
"/isolation-room-designs": {
  type: "service",
  title: "Isolation Room Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides infection-control-focused isolation room design solutions for hospitals, supporting patient safety, clinical workflow, ventilation requirements and effective healthcare environments.",
  keywords:
    "isolation room design, hospital isolation room design, infection control room design, hospital infection control, isolation ward design, healthcare facility design, hospital room planning, infection control infrastructure, hospital designers",
  priority: 0.6,
},
"/paediatric-ward-designs": {
  type: "service",
  title: "Paediatric Ward Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides child-friendly and safe paediatric ward design solutions focused on patient comfort, safety, efficient clinical workflows and functional healthcare environments.",
  keywords:
    "paediatric ward design, pediatric ward design, paediatric hospital design, pediatric hospital design, children ward design, paediatric ward planning, pediatric healthcare design, hospital ward design, healthcare interior design, hospital designers",
  priority: 0.6,
},
"/oncology-unit-designs": {
  type: "service",
  title: "Oncology Unit Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides specialized oncology unit design solutions focused on patient care workflows, clinical functionality, safety, comfort and efficient healthcare environments.",
  keywords:
    "oncology unit design, oncology centre design, cancer centre design, oncology hospital design, cancer care facility design, oncology ward design, oncology unit planning, hospital oncology design, healthcare facility design, hospital designers",
  priority: 0.6,
},
"/maternity-suite-designs": {
  type: "service",
  title: "Maternity Suite Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides comfortable and functional maternity suite design solutions focused on patient comfort, safety, efficient clinical workflows and modern healthcare environments.",
  keywords:
    "maternity suite design, maternity ward design, maternity hospital design, maternity unit planning, hospital maternity design, maternity room design, labour room design, healthcare facility design, hospital interior design, hospital designers",
  priority: 0.6,
},
"/lab-pathology-designs": {
  type: "service",
  title: "Lab & Pathology Design | PR Hospital Designers",
  description:
    "PR Hospital Designers provides efficient laboratory and pathology department design solutions for hospitals, focused on functional workflows, safety, space planning and modern healthcare requirements.",
  keywords:
    "lab design, laboratory design, pathology lab design, hospital laboratory design, pathology department design, diagnostic laboratory design, hospital lab planning, medical laboratory design, healthcare facility design, hospital designers",
  priority: 0.6,
},
"/bhuvanagiri": {
  type: "city",
  city: "Bhuvanagiri",
  title: "Hospital Designers in Bhuvanagiri | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital design, planning, construction and healthcare infrastructure solutions for hospitals and healthcare facilities in Bhuvanagiri.",
  keywords:
    "hospital designers in Bhuvanagiri, hospital design Bhuvanagiri, hospital architects Bhuvanagiri, hospital construction Bhuvanagiri, hospital consultants Bhuvanagiri, healthcare infrastructure Bhuvanagiri, hospital interior design Bhuvanagiri, hospital planning Bhuvanagiri",
  priority: 0.7,
},
"/hyderabad": {
  type: "city",
  city: "Hyderabad",
  title: "Hospital Designers in Hyderabad | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital design, planning, construction and healthcare infrastructure solutions for hospitals and healthcare facilities in Hyderabad.",
  keywords:
    "hospital designers in Hyderabad, hospital design Hyderabad, hospital architects Hyderabad, hospital construction Hyderabad, hospital consultants Hyderabad, healthcare infrastructure Hyderabad, hospital interior design Hyderabad, hospital planning Hyderabad",
  priority: 0.7,
},
"/indresham": {
  type: "city",
  city: "Indresham",
  title: "Hospital Designers in Indresham | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital design, planning, construction and healthcare infrastructure solutions for hospitals and healthcare facilities in Indresham.",
  keywords:
    "hospital designers in Indresham, hospital design Indresham, hospital architects Indresham, hospital construction Indresham, hospital consultants Indresham, healthcare infrastructure Indresham, hospital interior design Indresham, hospital planning Indresham",
  priority: 0.7,
},
"/jangaon": {
  type: "city",
  city: "Jangaon",
  title: "Hospital Designers in Jangaon | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital design, planning, construction and healthcare infrastructure solutions for hospitals and healthcare facilities in Jangaon.",
  keywords:
    "hospital designers in Jangaon, hospital design Jangaon, hospital architects Jangaon, hospital construction Jangaon, hospital consultants Jangaon, healthcare infrastructure Jangaon, hospital interior design Jangaon, hospital planning Jangaon",
  priority: 0.7,
},
"/khammam": {
  type: "city",
  city: "Khammam",
  title: "Hospital Designers in Khammam | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital design, planning, construction and healthcare infrastructure solutions for hospitals and healthcare facilities in Khammam.",
  keywords:
    "hospital designers in Khammam, hospital design Khammam, hospital architects Khammam, hospital construction Khammam, hospital consultants Khammam, healthcare infrastructure Khammam, hospital interior design Khammam, hospital planning Khammam",
  priority: 0.7,
},
"/mahabubnagar": {
  type: "city",
  city: "Mahabubnagar",
  title: "Hospital Designers in Mahabubnagar | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital design, planning, construction and healthcare infrastructure solutions for hospitals and healthcare facilities in Mahabubnagar.",
  keywords:
    "hospital designers in Mahabubnagar, hospital design Mahabubnagar, hospital architects Mahabubnagar, hospital construction Mahabubnagar, hospital consultants Mahabubnagar, healthcare infrastructure Mahabubnagar, hospital interior design Mahabubnagar, hospital planning Mahabubnagar",
  priority: 0.7,
},
"/narsapur": {
  type: "city",
  city: "Narsapur",
  title: "Hospital Designers in Narsapur | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital design, planning, construction and healthcare infrastructure solutions for hospitals and healthcare facilities in Narsapur.",
  keywords:
    "hospital designers in Narsapur, hospital design Narsapur, hospital architects Narsapur, hospital construction Narsapur, hospital consultants Narsapur, healthcare infrastructure Narsapur, hospital interior design Narsapur, hospital planning Narsapur",
  priority: 0.7,
},
"/rajahmundry": {
  type: "city",
  city: "Rajahmundry",
  title: "Hospital Designers in Rajahmundry | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital design, planning, construction and healthcare infrastructure solutions for hospitals and healthcare facilities in Rajahmundry.",
  keywords:
    "hospital designers in Rajahmundry, hospital design Rajahmundry, hospital architects Rajahmundry, hospital construction Rajahmundry, hospital consultants Rajahmundry, healthcare infrastructure Rajahmundry, hospital interior design Rajahmundry, hospital planning Rajahmundry",
  priority: 0.7,
},
"/sangareddy": {
  type: "city",
  city: "Sangareddy",
  title: "Hospital Designers in Sangareddy | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital design, planning, construction and healthcare infrastructure solutions for hospitals and healthcare facilities in Sangareddy.",
  keywords:
    "hospital designers in Sangareddy, hospital design Sangareddy, hospital architects Sangareddy, hospital construction Sangareddy, hospital consultants Sangareddy, healthcare infrastructure Sangareddy, hospital interior design Sangareddy, hospital planning Sangareddy",
  priority: 0.7,
},
"/vijayawada": {
  type: "city",
  city: "Vijayawada",
  title: "Hospital Designers in Vijayawada | PR Hospital Designers",
  description:
    "PR Hospital Designers provides hospital design, planning, construction and healthcare infrastructure solutions for hospitals and healthcare facilities in Vijayawada.",
  keywords:
    "hospital designers in Vijayawada, hospital design Vijayawada, hospital architects Vijayawada, hospital construction Vijayawada, hospital consultants Vijayawada, healthcare infrastructure Vijayawada, hospital interior design Vijayawada, hospital planning Vijayawada",
  priority: 0.7,
},
"/store-locator": {
  type: "page",
  title: "Hospital Designers Store Locator | PR Hospital Designers",
  description:
    "Find PR Hospital Designers locations and service areas for hospital design, construction, interior design and healthcare infrastructure solutions.",
  keywords:
    "PR Hospital Designers locations, hospital designers near me, hospital design locations, hospital consultants locations, hospital construction services, hospital designers Telangana, hospital designers Andhra Pradesh, healthcare infrastructure services",
  priority: 0.5,
},
"/careers": {
  type: "page",
  title: "Careers | Join PR Hospital Designers",
  description:
    "Explore career opportunities at PR Hospital Designers and join our team working on hospital design, construction, interiors and healthcare infrastructure projects.",
  keywords:
    "PR Hospital Designers careers, hospital design jobs, hospital architect jobs, hospital construction jobs, healthcare design jobs, hospital interior design jobs, healthcare infrastructure careers, hospital consultant jobs",
  priority: 0.4,
},
"/contact-us": {
  type: "page",
  title: "Contact PR Hospital Designers | Hospital Design & Construction",
  description:
    "Contact PR Hospital Designers for hospital architecture, construction, interior design, NABH consultancy and complete healthcare infrastructure solutions.",
  keywords:
    "contact PR Hospital Designers, hospital designers contact, hospital design consultants, hospital architects, hospital construction consultants, hospital interior designers, NABH consultants, healthcare infrastructure consultants, hospital planning consultants",
  priority: 0.6,
},
"/policies": {
  type: "page",
  title: "Policies | PR Hospital Designers",
  description:
    "Review the policies and guidelines of PR Hospital Designers Pvt Ltd regarding our services, website usage and business practices.",
  keywords:
    "PR Hospital Designers policies, hospital design company policies, website policies, company policies, PR Hospital Designers Pvt Ltd, hospital design services",
  priority: 0.3,
},
"/terms-and-conditions": {
  type: "page",
  title: "Terms & Conditions | PR Hospital Designers",
  description:
    "Read the terms and conditions governing the use of the PR Hospital Designers website and our hospital design, construction and healthcare infrastructure services.",
  keywords:
    "PR Hospital Designers terms and conditions, hospital design terms, website terms and conditions, hospital construction terms, healthcare services terms, PR Hospital Designers Pvt Ltd",
  priority: 0.3,
},
"/how-it-works": {
  type: "page",
  title: "How It Works | Hospital Design & Construction Process | PR Hospital Designers",
  description:
    "Understand how PR Hospital Designers manages hospital design, planning, construction, interiors and healthcare infrastructure projects from initial consultation to completion.",
  keywords:
    "how hospital design works, hospital design process, hospital construction process, hospital planning process, hospital interior design process, healthcare infrastructure process, hospital project planning, hospital design consultants, hospital construction consultants, PR Hospital Designers",
  priority: 0.5,
},
"/our-services": {
  type: "page",
  title: "Our Services | Hospital Design, Build & Equip | PR Hospital Designers",
  description:
    "Explore PR Hospital Designers' complete hospital design, architecture, construction, interior, MEP, medical equipment and healthcare infrastructure services.",
  keywords:
    "hospital design services, hospital construction services, hospital architecture services, hospital interior design services, healthcare infrastructure services, hospital MEP services, hospital equipment supply, NABH consultancy, hospital planning services, PR Hospital Designers",
  priority: 0.8,
},
"/hospital-journey": {
  type: "page",
  title: "Hospital Design Journey | From Planning to Completion | PR Hospital Designers",
  description:
    "Discover the complete hospital design journey with PR Hospital Designers, from initial planning and architecture to construction, interiors, infrastructure and final project completion.",
  keywords:
    "hospital design journey, hospital design process, hospital planning process, hospital construction process, hospital project journey, hospital architecture process, hospital interior design process, healthcare infrastructure planning, hospital project management, PR Hospital Designers",
  priority: 0.6,
},
"/consultation": {
  type: "page",
  title: "Book a Hospital Design Consultation | PR Hospital Designers",
  description:
    "Schedule a consultation with PR Hospital Designers for hospital architecture, planning, construction, interior design and complete healthcare infrastructure solutions.",
  keywords:
    "hospital design consultation, hospital consultant, hospital planning consultation, hospital architecture consultation, hospital construction consultation, hospital interior design consultation, healthcare infrastructure consultation, NABH hospital consultation, hospital design experts, PR Hospital Designers",
  priority: 0.6,
},
"/nabh-compliance": {
  type: "service",
  title: "NABH Compliance Services | PR Hospital Designers",
  description:
    "PR Hospital Designers provides end-to-end NABH compliance support to help hospitals plan, implement and maintain standards required for NABH accreditation.",
  keywords:
    "NABH compliance, NABH compliance services, NABH accreditation, NABH consultant, NABH hospital compliance, NABH standards, hospital NABH accreditation, NABH certification, hospital compliance consultant, NABH preparation",
  priority: 0.6,
},
"/doctor-feedback": {
  type: "page",
  title: "Doctor Feedback | PR Hospital Designers",
  description:
    "Read feedback from doctors and healthcare professionals about their experience with PR Hospital Designers' hospital design, planning and infrastructure solutions.",
  keywords:
    "doctor feedback, hospital designer reviews, doctor reviews, hospital design feedback, healthcare professional feedback, hospital design services, hospital architecture reviews, PR Hospital Designers reviews, hospital consultants",
  priority: 0.4,
},
};

// City landing pages — generated from the CITIES list so they stay consistent.
CITIES.forEach((city) => {
  const slug = city.toLowerCase();

  // Don't overwrite custom city SEO entries
  if (!seoConfig[`/${slug}`]) {
    seoConfig[`/${slug}`] = {
      type: "city",
      city,
      title: `Hospital Design & Build in ${city} | PR Hospital Designers`,
      description: `NABH-compliant hospital design, construction, and interior fit-out services in ${city}. Talk to PR Hospital Designers' local hospital planning experts.`,
      keywords: `hospital designers in ${city}, hospital design ${city}, hospital architects ${city}, hospital construction ${city}, hospital consultants ${city}, healthcare infrastructure ${city}, hospital interior design ${city}, hospital planning ${city}`,
      priority: 0.7,
    };
  }
});

export default seoConfig;
export { CITIES };